import { render, staticRenderFns } from "./BookingsPorConfirmarTabla.vue?vue&type=template&id=47ccb5ed"
import script from "./BookingsPorConfirmarTabla.vue?vue&type=script&lang=js"
export * from "./BookingsPorConfirmarTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports